import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ServiceWorkPage } from '../service-work-page/service-work-page';
import { ConfigService } from './config.service';
import { CoreService } from './core.service';

@Injectable({ providedIn: 'root' })
export class ServiceWorkService {
  private readonly configService = inject(ConfigService);
  private readonly coreService = inject(CoreService);
  private readonly matDialog = inject(MatDialog);

  openServicePage() {
    // A failed retry from the page itself lands here too; reopening would flash the app underneath.
    const isOpen = this.matDialog.openDialogs.some(
      (dialog) => dialog.componentInstance instanceof ServiceWorkPage,
    );
    if (isOpen) return;

    this.matDialog.closeAll();
    this.coreService.openDialog(ServiceWorkPage, this.configService.servicePageConfig);
  }
}
